import React, { useState, useContext } from 'react';
import { Navbar, Nav, Container, Form } from 'react-bootstrap';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Link } from 'react-scroll';
import styled from 'styled-components';
import ThemeToggler from './ThemeToggler';
import AppContext from '../AppContext';
import { getTranslation, supportedLanguages } from '../constants/translations';
import '../css/navbar.css';

const StyledNavLink = styled(Link)`
  color: white;
  margin: 0 10px;
  font-size: 1rem;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #1abc9c;
  }

  &.active {
    font-weight: bold;
    color: #1abc9c;
  }
`;

const StyledRouteLink = styled(RouterLink)`
  color: white;
  margin: 0 10px;
  font-size: 1rem;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #1abc9c;
  }
`;

const NavBar = () => {
  const { language, setLanguage } = useContext(AppContext);
  const t = getTranslation(language);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [data] = useState({
    sections: [
      { key: 'home', href: 'home', path: '/' },
      { key: 'services', href: 'services', path: '/#services' },
      { key: 'projects', href: 'projects', path: '/#projects' },
      { key: 'contact', href: 'contact', path: '/#contact' },
      { key: 'about', href: 'about', path: '/#about' },
    ],
  });
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar expand="lg" fixed="top" className="navbar-custom" expanded={expanded}>
      <Container>
        {/* Logo */}
        <Navbar.Brand href="/">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src="/images/logo.webp"
              alt="JR-AI-Consulting Logo"
              style={{
                height: 50,
                width: 50,
                marginRight: '10px',
              }}
            />
            <span style={{ fontWeight: 'bold', fontSize: '1.25rem', color: 'white' }}>
              JR-AI-Consulting
            </span>
          </div>
        </Navbar.Brand>

        {/* Toggle Button */}
        <Navbar.Toggle
  aria-controls="navbar-menu"
  className={`navbar-toggler ${expanded ? 'expanded' : ''}`}
  onClick={() => setExpanded(!expanded)}
>
  <span className="navbar-toggler-icon"></span>
</Navbar.Toggle>

        {/* Navigation Links */}
        <Navbar.Collapse id="navbar-menu">
          <Nav className="ms-auto">
            {data.sections.map((section) => (
              isHomePage && section.key !== 'einvoicing' ? (
                <StyledNavLink
                  key={section.href}
                  to={section.href}
                  smooth={true}
                  duration={500}
                  offset={-90}
                  spy={true}
                  onClick={() => setExpanded(false)}
                >
                  {t.nav[section.key]}
                </StyledNavLink>
              ) : (
                <StyledRouteLink
                  key={section.path}
                  to={section.path}
                  onClick={() => setExpanded(false)}
                >
                  {t.nav[section.key]}
                </StyledRouteLink>
              )
            ))}
          </Nav>

          <div className="navbar-controls">
            <Form.Select
              className="language-select"
              aria-label="Language selector"
              value={language}
              onChange={(e) => {
                setLanguage(e.target.value);
                setExpanded(false);
              }}
            >
              {supportedLanguages.map((item) => (
                <option key={item.code} value={item.code}>
                  {`${item.icon} ${item.label}`}
                </option>
              ))}
            </Form.Select>
            <div className="theme-toggle-slot">
              <ThemeToggler onClick={() => setExpanded(false)} />
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
